import { Link } from 'react-router-dom';

import type { ListingDetailLocationState } from './ListingDetailPage';
import { MapPin } from 'lucide-react';

import { formatDate, formatPlace } from '@/lib/format';
import type { Listing } from './hooks';
import styles from './FeedPage.module.css';

// Карточка ленты — вёрстка прототипа (заголовок + тег-пилюля, строка «город ·
// организация» с пином). Добавлена строка даты публикации: она есть в описании
// карточки ТЗ §2.4 / starling-vision.md §2, но в моке прототипа не рисовалась.

export interface ListingCardProps {
  listing: Listing;
  categoryName: string;
  language: string;
}

export function ListingCard({ listing, categoryName, language }: ListingCardProps): JSX.Element {
  return (
    <Link
      to={`/listings/${listing.id}`}
      state={{ fromFeed: true } satisfies ListingDetailLocationState}
      className={styles.card}
    >
      <div className={styles.cardTop}>
        <h3 className={styles.cardTitle}>{listing.title}</h3>
        <span className={styles.tag}>{categoryName}</span>
      </div>
      <div className={styles.cardMeta}>
        <MapPin size={11} aria-hidden="true" />
        {formatPlace(listing.city, listing.district)} · {listing.organization_name}
      </div>
      <div className={styles.cardDate}>{formatDate(listing.published_at, language)}</div>
    </Link>
  );
}
